import React from 'react';
import { Textfit } from 'react-textfit';
import Star from '@material-ui/icons/Star';
import StarBordered from '@material-ui/icons/StarBorder';
import { bodyFontSizesBOH } from '../../../helpers/utils';
export default function Comment({
  text,
  comment,
  satisfactionColor,
  formattedSatisfaction,
  formattedDate
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "header",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, !!(comment !== null && comment !== void 0 && comment.rating) && /*#__PURE__*/React.createElement("div", {
    className: "satisfaction",
    style: {
      backgroundColor: satisfactionColor
    }
  }, formattedSatisfaction)), /*#__PURE__*/React.createElement("div", {
    className: "date"
  }, formattedDate), /*#__PURE__*/React.createElement("div", {
    className: "quote"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content",
    style: {
      color: text.body_color,
      fontFamily: text.body_font_family
    }
  }, /*#__PURE__*/React.createElement(Textfit, {
    style: {
      maxHeight: 445,
      width: 1500,
      overflow: 'hidden',
      marginTop: 'auto'
    },
    mode: "multi",
    min: bodyFontSizesBOH.small,
    max: bodyFontSizesBOH.medium
  }, comment === null || comment === void 0 ? void 0 : comment.comment)), !!(comment !== null && comment !== void 0 && comment.rating) && /*#__PURE__*/React.createElement("div", {
    className: "rating"
  }, [1, 2, 3, 4, 5].map(i => i <= (comment === null || comment === void 0 ? void 0 : comment.rating) ? /*#__PURE__*/React.createElement(Star, {
    key: `star-${i}`
  }) : /*#__PURE__*/React.createElement(StarBordered, {
    key: `borderedStar-${i}`
  }))));
}